import React from 'react';
import clsx from 'clsx';

import { Preloader } from '../Preloader/Preloader';

import styles from './Button.module.scss';

export type ButtonTypes = 'primary' | 'bordered' | 'danger';
export type ButtonHtmlType = 'submit' | 'reset' | 'button';

export type ButtonProps = {
  className?: string;
  htmlType?: ButtonHtmlType;
  type?: ButtonTypes;
  disabled?: boolean;
  inProgress?: boolean;
  onClick?: () => void;
  id?: string;
};

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  type = 'primary',
  onClick,
  htmlType = 'button',
  inProgress = false,
  disabled,
  id,
}) => (
  <button
    id={id}
    type={htmlType}
    onClick={onClick}
    disabled={disabled}
    className={clsx(styles.root, 'px-3', styles[type], className, { [styles['is-disabled']]: disabled })}
  >
    {inProgress ? <Preloader className={styles.preloader} /> : children}
  </button>
);
